import React, { Component } from 'react'
import {
  GoogleMap,
  InfoBox,
  Marker,
  useJsApiLoader,
} from '@react-google-maps/api'
import getConfig from 'next/config'
const {
  publicRuntimeConfig: { GOOGLE_MAPS_API_KEY },
} = getConfig()
const CENTER_ZOOM_SIZE = 14

class BaseMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      center: props.center,
      zoom: props.zoom,
    }
    this.setCurrentLocationAsCenter = this.setCurrentLocationAsCenter.bind(this)
    this.changeMap = this.changeMap.bind(this)
  }

  componentDidUpdate() {
    if (
      this.props.center !== this.state.center ||
      this.props.zoom !== this.state.zoom
    ) {
      this.changeMap({
        center: this.props.center,
        zoom: this.props.zoom,
      })
    }
  }

  setCurrentLocationAsCenter(currentLocation) {
    this.changeMap({
      center: currentLocation,
      zoom: CENTER_ZOOM_SIZE,
    })
    if (this.props.onClickCurrentLocation) {
      this.props.onClickCurrentLocation()
    }
  }

  changeMap({ center, zoom }) {
    this.setState(
      {
        center: this.props.mapRef.getCenter(),
        zoom: this.props.mapRef.getZoom(),
      },
      () => {
        this.setState({
          zoom: zoom,
          center: center,
        })
      }
    )
  }

  render() {
    const {
      onMapMounted,
      defaultOptions,
      setCenter,
      currentLocation,
      children,
    } = this.props

    const { center, zoom } = this.state
    return (
      <GoogleMap
        onLoad={onMapMounted}
        mapContainerStyle={{ height: '100%', width: '100%' }}
        zoom={zoom}
        center={center || (setCenter && setCenter())}
        options={defaultOptions}
      >
        {currentLocation && (
          <Marker
            position={currentLocation}
            key={'current-location'}
            icon={{
              url: '/static/map-current-location.png',
              scaledSize: new window.google.maps.Size(21, 30),
            }}
            onClick={() => this.setCurrentLocationAsCenter(currentLocation)}
          />
        )}
        {children}
      </GoogleMap>
    )
  }
}

const GoogleMaps = props => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  })

  if (!isLoaded) {
    return null
  }

  return <BaseMap {...props} />
}
export default GoogleMaps

export { Marker, InfoBox }
